import "./TestPanelComponent.scss";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import _ from "lodash";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import commonService from "../../../shared/services/common.service";
import {Download} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import TestPanelListTableComponent from "./test-panel-list-table/TestPanelListTableComponent";
import TestPanelFiltersComponent from "./test-panel-filters/TestPanelFiltersComponent";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikInputComponent from "../../../shared/components/core/formik-input/FormikInputComponent";
import FormikAutoCompleteDropdown
    from "../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import FormikSelectDropdownComponent
    from "../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import {APIConfig} from "../../../constants";
import useFetch from "../../../shared/hooks/useFetch";

interface TestPanelComponentProps {

}

const FiltersInitialState: any = {
    search: '',
    createdByObjs: [],
    createdByIds: [],
    startDate: '',
    endDate: ''
}
const MODULE_NAME = "TestPanelList"

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['createdByObjs'];

const AddTestPanelvailidationSchema = Yup.object({
    name: Yup.string().required('Test Panel Name is required'),
    code: Yup.string().min(4).max(4).required('Test Panel Code is required'),
    sampleType: Yup.string().required('Test Panel Sample Type is required'),
    testIds: Yup.array().min(1).required('Test is required'),
    labIds: Yup.array().nullable(),
    description: Yup.string().nullable(),
})

const AddTestPanelInitialValues = {
    name: '',
    code: '',
    sampleType: '',
    testIds: [],
    labIds: [],
    description: '',
}


const TestPanelComponent = (props: TestPanelComponentProps) => {

    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {sampleTypeWithCollectionDevices} = useSelector((state: IRootReducerState) => state.staticData);
    const {testPanelStatusList, userList} = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [isAddTestPanelDrawerOpen, setIsAddTestPanelDrawerOpen] = useState<boolean>(false);
    const [addTestPanelFormInitialValues, setAddTestPanelFormInitialValues] = useState<any>(_.cloneDeep(AddTestPanelInitialValues));
    const {labListLite} = useSelector((state: IRootReducerState) => state.staticData);

    const {
        response: testListLite = [],
        loading: isTestListLiteLoading,
        loadingFailed: isTestListLiteError,
        fetchData: fetchTestList
    } = useFetch<any>();

    const getTestListLite = useCallback((sampleType: string) => {
        fetchTestList({
            url: APIConfig.TEST_LIST_LITE.URL,
            method: APIConfig.TEST_LIST_LITE.METHOD,
            payload: {
                isActive: true,
                sampleType
            }
        })
    }, [fetchTestList])

    useEffect(() => {
        dispatch(setCurrentNavParams("Test Panel", "Test", CommonService._routeConfig.TestListRoute()));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._test.downloadTestPanelCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'testList', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, testPanelStatusList, userList]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    const onTestPanelAdd = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        const payload = {...values};
        payload.testIds = payload.testIds.map((item: any) => item.id);
        payload.labIds = payload.labIds.map((item: any) => item.id);
        setSubmitting(true);
        CommonService._test.addTestPanel(payload)
            .then((response: IAPIResponseType<any>) => {
                if (response && response?.data) {
                    setIsAddTestPanelDrawerOpen(false);
                    setAddTestPanelFormInitialValues(_.cloneDeep(AddTestPanelInitialValues));
                }
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                setSubmitting(false);
            })
            .catch((error: any) => {
                setSubmitting(false);

            });
    }, []);

    return (
        <div className={'test-panel-component screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Test Panel"}
                                id="search_input"
                                placeholder={"Search by test panel name"}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('Test', 'testPanelCsvDownload', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"contained"}
                                    fullWidth={false}
                                    isLoading={isCSVDownloading}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }
                            {commonService.checkAccess('Test', 'addTestPanel', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    id="add_test_btn"
                                    handleClick={() => setIsAddTestPanelDrawerOpen(true)}
                                    startIcon={<AddIcon/>}
                                >
                                    New Test Panel
                                </ButtonComponent>
                            }
                        </div>
                    </div>
                    <>
                        <TestPanelListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>
            <DrawerComponent open={showFilterDrawer}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             className={"drawer-wrapper"}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <TestPanelFiltersComponent
                    filtersData={filterData} onFiltersApply={applyFilters} clearAllFilters={clearAllFilters}
                />
            </DrawerComponent>
            <DrawerComponent
                open={isAddTestPanelDrawerOpen}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                title={'Add Test Panel'}
                className={"drawer-wrapper"}
                onClose={() => setIsAddTestPanelDrawerOpen(false)}
            >
                <div className={'test-panel-details-component screen t-form-screen'}>
                    <div className="t-form t-form-drawer">
                        <Formik
                            initialValues={addTestPanelFormInitialValues}
                            onSubmit={onTestPanelAdd}
                            validationSchema={AddTestPanelvailidationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                        >
                            {({isSubmitting, values, isValid, setFieldValue, validateForm, errors}) => {
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                useEffect(() => {
                                    validateForm();
                                }, [values, errors, validateForm]);
                                return (
                                    <Form noValidate={true} className={"panel-add-holder"}>
                                        <div className="t-form-controls-wrapper pdd-top-25">
                                            <Field name={'name'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Test Panel Name'}
                                                            placeholder={'Enter Test Panel Name'}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                            <Field name={'code'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Test Panel Code'}
                                                            placeholder={'Enter Test Panel Code'}
                                                            type={"text"}
                                                            maxLength={4}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                            <Field name={'sampleType'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Sample Type'}
                                                            options={sampleTypeWithCollectionDevices}
                                                            placeholder={'Select Sample Type'}
                                                            valueKey={'sampleType'}
                                                            required={true}
                                                            getOptionLabel={(option) => (commonService.capitalizeFirstLetter(option.sampleType)) || ''}
                                                            formikField={field}
                                                            onUpdate={(value: any) => {
                                                                value && getTestListLite(value);
                                                                setFieldValue('testIds', []);
                                                            }
                                                            }
                                                        />
                                                    )}
                                            </Field>
                                            <Field name={'testIds'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikAutoCompleteDropdown
                                                            label={'Select Test(s)'}
                                                            placeholder={'Select Test(s)'}
                                                            data={values.sampleType ? testListLite : []}
                                                            isDataLoading={isTestListLiteLoading}
                                                            isDataLoadingFailed={isTestListLiteError}
                                                            multiple={true}
                                                            required={true}
                                                            valueKey={'id'}
                                                            formikField={field}
                                                            getOptionLabel={(option: any) => option?.name}
                                                        />
                                                    )
                                                }
                                            </Field>
                                            <Field name={'labIds'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikAutoCompleteDropdown
                                                            label={'Assign Lab(s)'}
                                                            placeholder={'Select Lab(s)'}
                                                            data={labListLite}
                                                            required={false}
                                                            multiple={true}
                                                            formikField={field}
                                                            valueKey={'id'}
                                                            getOptionLabel={(option: any) => option?.name}
                                                        />
                                                    )
                                                }
                                            </Field>
                                            <Field name={'description'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Description (if any)'}
                                                            placeholder={'Enter Description'}
                                                            type={"text"}
                                                            multiline={true}
                                                            rows={4}
                                                            required={false}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="drawer-actions form-action-section">
                                            <ButtonComponent variant={"contained"}
                                                             fullWidth={true}
                                                             type={"submit"}
                                                             disabled={!isValid}
                                                             isLoading={isSubmitting}
                                            >
                                                Save
                                            </ButtonComponent>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </div>
            </DrawerComponent>
        </div>
    );

};

export default TestPanelComponent;
